/**
 * Converts YouTube URLs to use the no-cookie domain for better privacy compliance
 * @param url - The original YouTube URL
 * @returns The converted no-cookie URL or the original URL if not a YouTube URL
 */
export const convertToNoCookieUrl = (url: string): string => {
  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    return url
      .replace('youtube.com', 'youtube-nocookie.com')
      .replace('youtu.be/', 'youtube-nocookie.com/embed/');
  }
  return url;
};